export const stringify = object => {

    let array = Object.keys(object).map(key => {
        return {[key] : object[key]}
    })

    return array.reduce((acc, current) => {
        let stringified = Object.keys(current).reduce((a, c) => current[c] ? `${a}${c}=${current[c]}` : "", "")
        return stringified ? `${acc}&${stringified}` : acc
    }, "")
}

export const parse = string => {
    let params = new URLSearchParams(string)
    return Object.fromEntries([...params])
}

export const encode = pObj => {
    let params = new URLSearchParams(pObj)
    return params.toString()
}
